import { addDoc, collection, limit, onSnapshot, orderBy, query, Timestamp } from 'firebase/firestore';
import { auth, db } from '../../firebaseConfig';
import { logListenerError } from '../db';

/**
 * Append an entry to "admin_audit_logs" as the signed-in user. Security rules only accept
 * entries written by signed-in clients as themselves, so this is a no-op (null) when signed out.
 * Resolves the stored entry.
 */
export async function writeAuditLog(entry) {
  const user = auth.currentUser;
  if (!user) return null;
  const stored = {
    ...entry,
    actorEmail: user.email || '',
    actorUid: user.uid,
    timestamp: Timestamp.now(),
  };
  await addDoc(collection(db, 'admin_audit_logs'), stored);
  return stored;
}

/** The latest audit entries, newest first, with timestamp as a Date. */
export function subscribeAuditLogs(max, onChange, onError = logListenerError('admin_audit_logs')) {
  return onSnapshot(query(collection(db, 'admin_audit_logs'), orderBy('timestamp', 'desc'), limit(max)), (snapshot) => {
    onChange(snapshot.docs.map((snap) => {
      const data = snap.data();
      return { id: snap.id, ...data, timestamp: data.timestamp?.toDate?.() || new Date(data.clientTime || Date.now()) };
    }));
  }, onError);
}
